import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-install-modal',
  templateUrl: './install-modal.component.html',
  styleUrls: ['./install-modal.component.css']
})
export class InstallModalComponent implements OnInit {

  isModalVisible: boolean = false;
  deferredPrompt: any;

  constructor() { }

  ngOnInit(): void {
    // Listen for install prompt event
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();          // Prevent auto-prompt
      this.deferredPrompt = event;    // Store the event

      // Optionally, show modal automatically or let user trigger it later
      // this.showModal();
    });
  }
  showModal() {
    this.isModalVisible = true;
  }

  closeModal() {
    this.isModalVisible = false;
  }


  installApp() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(choice => {
        if (choice.outcome === 'accepted') console.log('Accepted');
        else console.log('Dismissed');
        this.deferredPrompt = null;
      });
    } else {
      console.warn('Install not ready yet.');
    }
  }


}
